import React, { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';
import ClipLoader from 'react-spinners/ClipLoader';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import 'react-phone-number-input/style.css'
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';

const override = {
  display: 'block',
  margin: '0 auto',
  borderColor: 'red',
};

const Airport = () => {

  //const [startDepartureDate, setStartDepartureDate] = useState(null);
  //const [startDate, setStartDate] = useState(new Date());
  const [startDate, setStartDate] = useState(null);
  const [dateError, setDateError] = useState('');

  const [endDate, setEndDate] = useState(null);
  //const [endDateError, setEndDateError] = useState('');

  const handleStartDateChange = (date) => {
    //console.log(date);
    setStartDate(date);
    setForm({ ...form, date: date });
    setDateError('');

    setEndDate(null);
    //setForm({ ...form, returndate: '' });
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setForm({ ...form, returndate: date });
    //setEndDateError('');    
  };

  const [isDivVisible, setIsDivVisible] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [passengerCount, setPassengerCount] = useState(1); // Initial passenger count
  const [BagsCount, setBagsCount] = useState(1); // Initial passenger count
  const [valuePhone, setValuePhone] = useState();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');  
  const [queryFrom, setQueryFrom] = useState('');
  const [queryTo, setQueryTo] = useState('');
  const [resultsFrom, setResultsFrom] = useState([]);
  const [resultsTo, setResultsTo] = useState([]);
  const [selectedFrom, setSelectedFrom] = useState('');
  const [selectedTo, setSelectedTo] = useState('');
  const [loadingFrom, setLoadingFrom] = useState(false);
  const [loadingTo, setLoadingTo] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    from: '',
    to: '',
    title: 'Mr',
    name: '',
    lastname: '',
    phone: '',
    email: '',
    date: '',
    returndate: '',
    passengers: '1',
    //bags: '1',
    message: '',
  });
  const [fromError, setFromError] = useState('');
  const [toError, setToError] = useState('');
  const [nameError, setNameError] = useState(''); 
  const [namelastError, setNameLastError] = useState('');

  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');  
  const [passengersError, setPassengersError] = useState('');
  const [bagError, setBagError] = useState('');
  //const [messageError, setMessageError] = useState('');

  const fetchResults = async (searchQuery, setLoading, setResults) => {
    setError('');
    setResults([]);
    setLoading(true);
    try {
      const response = await fetch(
        `${airportappLocalizer.apiUrl}/airport/v1/search?code=${searchQuery}`
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setResults(data);
    } catch (error) {
      setError('Failed to fetch data: ' + error.message);
      console.log('Failed to fetch data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchResultsFrom = useCallback(
    debounce((searchQuery) => {
      fetchResults(searchQuery, setLoadingFrom, setResultsFrom);
    }, 300), // 300ms delay
    []
  );

  const debouncedFetchResultsTo = useCallback(
    debounce((searchQuery) => {
      fetchResults(searchQuery, setLoadingTo, setResultsTo);
    }, 300), // 300ms delay
    []
  );

  useEffect(() => {
    if (queryFrom.length >= 2) {
      debouncedFetchResultsFrom(queryFrom);
    } else {
      setResultsFrom([]);
    }
  }, [queryFrom, debouncedFetchResultsFrom]);

  useEffect(() => {
    if (queryTo.length >= 2) {
      debouncedFetchResultsTo(queryTo);
    } else {
      setResultsTo([]);
    }
  }, [queryTo, debouncedFetchResultsTo]);

  const handleSuggestionClickFrom = (result) => {
    const selectedText = `${result.air_name} - ${result.air_place} (${result.air_code})`;
    setSelectedFrom(selectedText);
    setQueryFrom(selectedText);
    setResultsFrom([]);
    setForm({ ...form, from: result.air_name });
    setFromError(''); // Clear error on selection
    
  };

  const handleSuggestionClickTo = (result) => {
    const selectedText = `${result.air_name} - ${result.air_place} (${result.air_code})`;
    setSelectedTo(selectedText);
    setQueryTo(selectedText);
    setResultsTo([]);
    setForm({ ...form, to: result.air_name });
    setToError(''); // Clear error on selection
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    // Clear the specific error on change
    if (name === 'from') setFromError('');
    if (name === 'to') setToError('');
    if (name === 'name') setNameError('');
    if (name === 'lastname') setNameLastError('');
    if (name === 'phone') setPhoneError('');
    if (name === 'email') setEmailError('');
    if (name === 'date') setDateError('');
    //if (name === 'returndate') endDateError('');
    //if (name === 'message') setMessageError('');
  };

  const validateForm = () => {
    let errors = {};
    if (!form.from) {
      //setQueryFrom('');      
      errors.from = 'From field is required';
      setFromError('From field is required');
    }
    if (!form.to) {
      //setQueryTo('');
      errors.to = 'To field is required';
      setToError('To field is required');
    }
    if (!form.name) {
      errors.to = 'First Name field is required';
      setNameError('First Name field is required');
    }
    if (!form.lastname) {
      errors.to = 'Last Name field is required';
      setNameLastError('Last Name field is required');
    }    
    
    if (!form.phone) {
      errors.phone = 'Phone field is required';
      setPhoneError('Phone field is required');
    /*} else if (!/^\d{10,13}$/.test(form.phone)) {
      errors.phone = 'Phone number must be between 10 and 13 digits';
      setPhoneError('Phone number must be between 10 and 13 digits');*/
    }
    
    if (!form.email) {
      errors.email = 'Email field is required';
      setEmailError('Email field is required');
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errors.email = 'Email address is invalid';
      setEmailError('Email address is invalid');
    }
    if (!form.date) {
      errors.date = 'Date field is required';
      setDateError('Date field is required');
    }else{
      setDateError('');
    }    
    /*if (!form.message) {
      errors.message = 'Message field is required';
      //setMessageError('Message field is required');
    }*/

    return Object.keys(errors).length === 0;
  };

  //const handleSubmit = (e) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Handle form submission
      //console.log('Form submitted:', form);
      //console.log('Form submitted stringify:', JSON.stringify(form));
      setLoadingSubmit(true); // Start the loader
        try {
          const response = await fetch(`${airportappLocalizer.apiUrl}/airport/v1/airenquiry`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(form)
          });
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.json();
          //console.log('Form submitted:', data);
          setSuccessMessage(data);
          //setSuccessMessage('Thank you! Your enquiry has been submitted successfully.');
          // Optionally clear the form after successful submission
          setForm({
            from: '',
            to: '',
            title: 'Mr',
            name: '',
            lastname: '',
            phone: '',
            email: '',
            date: '',
            returndate: '',
            passengers: '1',
            //bags: '1',
            message: '',
          });
          setQueryFrom('');
          setQueryTo('');
          setValuePhone('');
          setPhoneError('');

          setStartDate('');
          setEndDate('');



        } catch (error) {
          setError('Failed to submit data: ' + error.message);
          //console.log('Failed to submit data: ' + error.message);
        } finally {
          setLoadingSubmit(false); // Stop the loader
          //setSuccessMessage('');
        }
    }
  };

  const handleBlur = (inputType) => {
    if (inputType === 'from') {
      // Hide the auto-suggestion for 'from' input
      document.body.addEventListener('click', handleBodyClick);
    }
    if (inputType === 'to') {
      // Hide the auto-suggestion for 'to' input
      document.body.addEventListener('click', handleBodyClick);
    }
  };
  
  const handleBodyClick = (event) => {
    // Check if the click target is not within the auto-suggestion list
    if (!event.target.closest('.autosuggestion_from') && !event.target.closest('.autosuggestion_to')) {
      // Perform actions to hide the auto-suggestion
      setResultsFrom([]);
      setResultsTo([]);
      // Remove the event listener to prevent multiple bindings
      document.body.removeEventListener('click', handleBodyClick);
    }
  };
  
  // Function to handle incrementing the passenger count
  const handleIncrement = () => {
      setPassengerCount(prevCount => prevCount + 1);
      setForm({ ...form, passengers: passengerCount + 1 });
  };

  // Function to handle decrementing the passenger count
  const handleDecrement = () => {
      if (passengerCount > 1) {
          setPassengerCount(prevCount => prevCount - 1);
          setForm({ ...form, passengers: passengerCount - 1});
      }
  };

  // Function to handle incrementing the passenger count
  /*const handleIncrementBags = () => {
      setBagsCount(prevCount => prevCount + 1);
      setForm({ ...form, bags: BagsCount + 1});
  };

  // Function to handle decrementing the passenger count
  const handleDecrementBags = () => {
      if (BagsCount > 1) {
          setBagsCount(prevCount => prevCount - 1);
          setForm({ ...form, bags: BagsCount - 1});
      }
  };*/

  const handleChange = (phoneNumber) => {
    setValuePhone(phoneNumber);
    if (phoneNumber) {
      if (!isPossiblePhoneNumber(phoneNumber)) {
        setPhoneError('Invalid phone number length');
        setForm({ ...form, phone: '' });
        //console.log("hello 1"+ phoneNumber);
      } else {
        if(valuePhone && isValidPhoneNumber(phoneNumber)){
          setPhoneError('');
          setValuePhone(phoneNumber);
          setForm({ ...form, phone: phoneNumber });
          //console.log("hello 2"+ phoneNumber);
        }else{
          setPhoneError('Invalid Phone number');
          setForm({ ...form, phone: '' });
          //console.log("hello 4"+ phoneNumber);          
        }
        
      }
    } else {
      setPhoneError('Phone number required');
      setForm({ ...form, phone: '' });
      //console.log("hello 3"+ phoneNumber);      
    }
  };

  const handleNextClick = () => {
    setIsDivVisible(true);
    setIsButtonDisabled(true);
  };

  useEffect(() => {
    if (startDate && queryFrom && queryTo) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [startDate, queryFrom, queryTo]);
  

  
  

  return (    
    <div className="booking-form-cont">
        <div className="cust-container">            
            <form onSubmit={handleSubmit} autoComplete="off" className="booking-form">
              <div className="search-flight-cont">
                  <div className="form-inline-cont">
                      <div className="cust-form-group group-from-to">
                          <input
                            className="cust-form-control from-input"
                            autoComplete="off"
                            autoCorrect="off"
                            type="text"
                            name="from"
                            value={queryFrom}
                            onChange={(e) => {
                              setFromError('');
                              setSelectedFrom('');
                              const { value } = e.target;
                              if (e.target.value === '') { 
                                setForm({ ...form, from: '' }); 
                                setQueryFrom('');
                              } else {
                                setQueryFrom(e.target.value);
                              }
                            }}
                            onBlur={() => handleBlur('from')}
                            placeholder='Enter at least 2 characters'
                          />
                          {fromError && <div className="error-validation" style={{ color: 'red' }}>{fromError}</div>}
                          {error && <div className="error-validation" style={{ color: 'red' }}>{error}</div>}
                          <div className={`autosuggestion_from autosuggestion-react ${resultsFrom.length > 0 ? 'active' : ''}`}>
                            {loadingFrom && <ClipLoader cssOverride={override} size={20} aria-label="Loading Spinner" data-testid="loader" className="airport_from_loader reactjs_loader"/>}
                            <ul>
                              {resultsFrom.map((result) => (
                                <li key={result.air_id} onClick={() => handleSuggestionClickFrom(result)}>
                                  <strong>{result.air_name}</strong> - {result.air_place} ({result.air_code})
                                </li>
                              ))}
                            </ul>
                          </div>
                      </div>
                      <div className="cust-form-group group-from-to">
                        <input
                            className="cust-form-control from-input"
                            type="text"
                            autoComplete="off"
                            autoCorrect="off"
                            name="to"
                            value={queryTo}
                            onChange={(e) => {
                              setToError('');
                              setSelectedTo('');
                              const { value } = e.target;
                              if (e.target.value === '') {
                                setForm({ ...form, to: '' });        
                                setQueryTo('');
                              } else {
                                setQueryTo(e.target.value); 
                              }
                            }}
                            onBlur={() => handleBlur('to')}
                            placeholder='Enter at least 2 characters'
                          />
                          {toError && <div className="error-validation" style={{ color: 'red' }}>{toError}</div>}
                          {error && <div className="error-validation" style={{ color: 'red' }}>{error}</div>}
                          <div className={`autosuggestion_to autosuggestion-react ${resultsTo.length > 0 ? 'active' : ''}`}>
                            {loadingTo && <ClipLoader cssOverride={override} size={20} className="airport_to_loader reactjs_loader" />}
                            <ul>
                              {resultsTo.map((result) => (
                                <li key={result.air_id} onClick={() => handleSuggestionClickTo(result)}>
                                  <strong>{result.air_name}</strong> - {result.air_place} ({result.air_code})
                                </li>
                              ))}
                            </ul>
                          </div>
                      </div>
                      <div className="cust-form-group group-date no-border from-date">
                        <DatePicker
                          name="date"
                          placeholderText='Date'
                          className="cust-form-control date-input"
                          selected={startDate}
                          onChange={handleStartDateChange}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          dateFormat="MMMM d yyyy"
                          minDate={new Date()}
                        />                          
                          {dateError && <div className="error-validation" style={{ color: 'red' }}>{dateError}</div>}
                      </div>
                      <div className="cust-form-group group-date returndate">
                        <DatePicker
                            name="returndate"
                            placeholderText='Add return'
                            className="cust-form-control date-input date-input-returndate"
                            selected={endDate}
                            onChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            dateFormat="MMMM d yyyy"
                            value={form.returndate}
                            minDate={startDate ? startDate : new Date()}
                          />                      
                          {/* {endDateError && <div className="error-validation" style={{ color: 'red' }}>{endDateError}</div>} */}
                      </div>
                      <div className="cust-form-group group-passenger no-border">
                          <div className="passenger-box">
                              <a className="plus-minus-btn btn-minus" href="javascript:void(0);" onClick={handleDecrement}>
                                  <img className="btn-icon" src={airportappLocalizer.icon_minus} alt="Icon Minus Rounded" />
                              </a>
                              <span className="passenger-count">
                                <input
                                    type="text"
                                    name="passengers"
                                    value={passengerCount}
                                    onChange={(e) =>{
                                      setPassengerCount(parseInt(e.target.value) || 1);
                                      setForm({ ...form, passengers: parseInt(e.target.value) });
                                    }} // Ensure input value is a number
                                    min="1"
                                />
                                {` Passenger${passengerCount > 1 ? 's' : ''}`}
                                </span>
                              <a className="plus-minus-btn btn-plus" href="javascript:void(0);" onClick={handleIncrement}>
                                  <img className="btn-icon" src={airportappLocalizer.icon_plus} alt="Icon Plus Rounded" />
                              </a>
                          </div>
                      </div>
                      {/* <div className="cust-form-group group-passenger no-border">
                          <div className="passenger-box">
                              <a className="plus-minus-btn btn-minus" href="javascript:void(0);" onClick={handleDecrementBags}>
                                  <img className="btn-icon" src={airportappLocalizer.icon_minus} alt="Icon Minus Rounded" />
                              </a>
                              <span className="passenger-count">
                                <input
                                    type="text"
                                    value={BagsCount}
                                    name="bags"
                                    onChange={(e) =>{
                                      setBagsCount(parseInt(e.target.value) || 1);
                                      setForm({ ...form, bags: e.target.value });
                                    }}
                                    min="1"
                                />
                                Bags</span>
                              <a className="plus-minus-btn btn-plus" href="javascript:void(0);" onClick={handleIncrementBags}>
                                  <img className="btn-icon" src={airportappLocalizer.icon_plus} alt="Icon Plus Rounded" />
                              </a>
                          </div>
                      </div> */}
                  </div>
                  <a 
                    className="common-btn btn-search nextstep_fordetails" 
                    href="javascript:void(0)" 
                    id="nextstep_fordetails" 
                    onClick={handleNextClick} 
                    style={{ pointerEvents: isButtonDisabled ? 'none' : 'auto', opacity: isButtonDisabled ? 0.5 : 1 }}
                  >
                    Search
                  </a>
              </div>

              {isDivVisible && (
                <div className="request-flight-cont" id='next_fielddetails'>
                    <div className="cust-row">
                        <div className="cust-col cust-col-6">
                            <div className="cust-form-group">
                                <label className="cust-form-label">Title</label>
                                <select 
                                  className="cust-form-control select-title" 
                                  name="title"
                                  value={form.title}
                                  onChange={handleInputChange}
                                >
                                    <option value="Mr">Mr</option>
                                    <option value="Mrs">Mrs</option>
                                    <option value="Miss">Miss</option>
                                    <option value="Dr">Dr</option>
                                </select>
                            </div>
                            <div className="cust-form-group">
                                <label className="cust-form-label">First Name</label>
                                <input
                                    className="cust-form-control"
                                    autoComplete="new-password"
                                    autoCorrect="off"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleInputChange}
                                    placeholder='First name'
                                  />
                                  {nameError && <div className="error-validation" style={{ color: 'red' }}>{nameError}</div>}
                            </div>
                            <div class="cust-form-group">
                                <label className="cust-form-label">Last name</label>
                                <input
                                    className="cust-form-control"
                                    autoComplete="new-password"
                                    autoCorrect="off"
                                    type="text"
                                    name="lastname"
                                    value={form.lastname}
                                    onChange={handleInputChange}
                                    placeholder='Last name'
                                  />
                                  {namelastError && <div className="error-validation" style={{ color: 'red' }}>{namelastError}</div>}
                            </div>
                            <div class="cust-form-group">
                                <label className="cust-form-label">Email</label>
                                <input
                                  className="cust-form-control"
                                  autoComplete="new-password"
                                  autoCorrect="off"
                                  type="email"
                                  name="email"
                                  value={form.email}
                                  onChange={handleInputChange}
                                  placeholder='Email'
                                />
                                {emailError && <div className="error-validation" style={{ color: 'red' }}>{emailError}</div>}
                            </div>
                            <div class="cust-form-group group-phone">
                                <label className="cust-form-label">Phone</label>
                                <PhoneInput
                                  placeholder="Enter phone number"
                                  value={valuePhone}
                                  onChange={handleChange}                                
                                  international
                                  name="phone"
                                  countryCallingCodeEditable={true}
                                  defaultCountry="GB"
                                  error={phoneError}
                                />
                                {phoneError && <div className="error-validation" style={{ color: 'red' }}>{phoneError}</div>}
                                {/* <div>Is possible: {valuePhone && isPossiblePhoneNumber(valuePhone) ? 'true' : 'false'}</div><br></br>
                                <div>Is valid: {valuePhone && isValidPhoneNumber(valuePhone) ? 'true' : 'false'}</div><br></br>
                                <div>National: {valuePhone && formatPhoneNumber(valuePhone)}</div><br></br>
                                <div>International: {valuePhone && formatPhoneNumberIntl(valuePhone)}</div><br></br> */}
                                                          
                            </div>
                        </div>
                        <div className="cust-col cust-col-6">
                            <h3 className="title-additional">Any additional requests that we may assist you with?</h3>
                            <p className="sub-title-additional">For example, dietary requirements, special requests.</p>
                            <div className="cust-form-group">
                                <textarea 
                                  className="cust-form-control"
                                  name="message"
                                            value={form.message}
                                            onChange={handleInputChange}
                                            placeholder="Message"
                                >
                                </textarea>
                                {/* {messageError && <div className="error-validation" style={{ color: 'red' }}>{messageError}</div>} */}
                            </div>
                        </div>
                    </div>
                    <div className="cust-form-group">
                        <input className="common-btn btn-request-flight" type="submit" value="REQUEST FLIGHT" />
                        {loadingSubmit && <ClipLoader cssOverride={override} size={50} aria-label="Loading Spinner" data-testid="loader" className="airport_insert_loader reactjs_loader"/>}
                        {successMessage && <span className='submit-success' style={{ color: 'green' }}>{successMessage}</span>}
                    </div>
                </div>
              )}
            </form>
        </div>
    </div>
  );
};

export default Airport;
